var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-container",style:({'background-color': this.$store.getters.skin.sidebarBackgroundColor})},[(!_vm.$store.getters.topNav)?_c('Logo'):_vm._e(),_c('SideMenu',{staticClass:"sidebar-menu"}),_c('Hamburger')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }